import React, { memo, ReactNode, useRef, useState } from 'react';
import cn from 'classnames';

import './PrepopulatedTextField.scss';

type Props = {
  name?: string;
  value: string;
  type: string;
  labelMuted?: boolean;
  placeholder?: string;
  label?: ReactNode | string;
  prepopulatedText?: string;
  className?: string;
  wrapperClassName?: string;
  inputIcon?: ReactNode;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

function PrepopulatedTextField({
  name,
  value,
  onChange,
  type,
  labelMuted = true,
  placeholder = '',
  prepopulatedText = '',
  onBlur,
  onFocus,
  label,
  inputIcon,
  className = '',
  onKeyDown,
  wrapperClassName = 'mb-3',
}: Props) {
  const inputRef = useRef(null);
  const [isFocus, setIsFocus] = useState(false);

  const handleFocus = event => {
    setIsFocus(true);
    setTimeout(() => {
      if (value === prepopulatedText) inputRef.current.setSelectionRange(0, 0);
    }, 10);
    if (onFocus) onFocus(event);
  };

  const handleBlur = event => {
    if (!value) {
      const newEvent = event;
      newEvent.target.value = prepopulatedText;
      onChange(newEvent);
    }
    setIsFocus(false);
    if (onBlur) onBlur(event);
  };

  return (
    <div className={`prepopulated-text-field d-flex flex-column w-100 ${wrapperClassName}`}>
      <span
        className={cn('prepopulated-text-field-label', {
          'text-field-mask-label--muted': labelMuted,
        })}
      >
        {label}
      </span>
      <div className="position-relative">
        {!isFocus && value === prepopulatedText && (
          <div className="prepopulated-text-field-placeholder py-1">
            <span className="text-muted">{placeholder}</span>
            {prepopulatedText}
          </div>
        )}
        <input
          ref={inputRef}
          className={`prepopulated-text-field form-control ${className}`}
          autoComplete="new-password"
          type={type}
          name={name}
          value={value === prepopulatedText && !isFocus ? '' : value}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onKeyDown={onKeyDown}
          onChange={onChange}
        />
        <div className="prepopulated-text-field-input-icon d-flex position-absolute">{inputIcon}</div>
      </div>
    </div>
  );
}

export default memo(PrepopulatedTextField);
